export default "__VITE_ASSET__CWdilXmf__"